import { render, staticRenderFns } from "./corneaMap.vue?vue&type=template&id=de4840b6&scoped=true&"
import script from "./corneaMap.vue?vue&type=script&lang=js&"
export * from "./corneaMap.vue?vue&type=script&lang=js&"
import style0 from "./corneaMap.vue?vue&type=style&index=0&id=de4840b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4840b6",
  null
  
)

export default component.exports